import { RecoilRoot } from 'recoil';
import RecoilNexus from 'recoil-nexus';
import { SwarmContextProvider } from '@lbs/swarm-client';
import { ToastContainer, CloseButtonProps } from 'react-toastify';

import Betslip, { IProps as IBetslipProps } from './components/betslip';
import reportWebVitals from './reportWebVitals';

import './assets/styles/style.scss';

function CloseButton({ closeToast }: CloseButtonProps) {
  return (
    <i
      className="global-icon icon-Close"
      onClick={closeToast}
    />
  );
}

const BetslipWrapper = (props: IBetslipProps) => {
  console.log('Betslip inside wrapper')

  return (<RecoilRoot>
    <RecoilNexus />
    <SwarmContextProvider>
      <ToastContainer
        position="top-right"
        autoClose={10000}
        hideProgressBar={false}
        enableMultiContainer
        newestOnTop
        theme="dark"
        containerId='Betslip-Toastify'
        closeButton={props.isMobile ? <></> : CloseButton}
        closeOnClick
        pauseOnHover={false}
      />
      <Betslip {...props} />
    </SwarmContextProvider>
  </RecoilRoot>)
}

reportWebVitals(report => console.log('about betslip performance', report));

export default BetslipWrapper;
